/**
 * RequestError — Network / HTTP request failures
 * 
 * Use this for transport-level errors: timeouts, DNS failures,
 * connection refused, or any HTTP status that isn't covered by
 * a more specific error class.
 */
export class RequestError extends Error {
    public readonly statusCode: number | undefined;
    public correlationId?: string;

    constructor(
        public readonly message: string,
        statusCode?: number,
        public readonly innerError?: Error
    ) {
        super(message);
        this.name = 'RequestError';
        this.statusCode = statusCode;
        Object.setPrototypeOf(this, RequestError.prototype);
    }

    public toString(): string {
        const status = this.statusCode ? ` [${this.statusCode}]` : '';
        return `RequestError${status}: ${this.message}`;
    }
}
